// loads scripts that need to be on page - every entrypoint should import this!
import { AdLoader, lazyload } from '@datagraphics/cookbook';
import { apmonth, intcomma } from 'journalize';
import resizer from './ai2html-resizer';

document.addEventListener('DOMContentLoaded', () => {
  // Kickstart image lazy loading
  lazyload();
  // Kickstart ads
  const adLoader = new AdLoader({ adSection: window.AD_SECTION });
  adLoader.init();
});

// Write your code!
import 'intersection-observer';
import { csv, json } from 'd3-fetch';
import { autoType } from 'd3-dsv';
import { renderSvelteComponent } from './utils/render.js';

//components
import LineChart from './components/LineChart.svelte';

async function main() {
  // For line charts
  const timeseriesContrib = new URL(
    '../_data/contributions_by_date.csv',
    import.meta.url
  );
  const timeDataContrib = await csv(timeseriesContrib, autoType);

  // // try this out
  // const url = new URL('../_data/races/test.json', import.meta.url);
  // const allData = await json(url);

  renderSvelteComponent(
    LineChart,
    /** @type {HTMLElement} */ (document.getElementById('linechart-raised')),
    {
      allData: timeDataContrib,
      candidates: ['Alex Villanueva', 'Robert Luna'],
      width: document.getElementById('linechart-raised').offsetWidth,
      chartType: 'raised',
      candidates_last: ['Villanueva', 'Luna'],
    }
  );
}

main();
